//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import(/* webpackChunkName: "herb" */ './indexAppl');
const edit = () => import('./edit.vue');
const recommend=()=>import('./recommend.vue');

export default {
  routes: [
    {
      path: '/investmentSubsidy/v2025/indexAppl',
      name: 'investmentSubsidy_v2025_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/investmentSubsidy/v2025/indexAdmin',
      name: 'investmentSubsidy_v2025_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/investmentSubsidy/v2025/edit',
      name: 'investmentSubsidy_v2025_edit',
      component: edit,
      meta: {public: true}
    },
    {
      path: '/investmentSubsidy/v2025/recommend',
      name: 'investmentSubsidy_v2025_recommend',
      component: recommend,
      meta: {public: true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/investmentSubsidy/v2025/router.js